import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as modalityActions } from '@/domain/useCases/getModalityOfStudy';

import ProfileView from './ProfileView';
import { formatProfile } from './helpers/format';
import ModuleContainer from '@/presentation/components/Container';

const ProfileViewController = () => {
  const user = useSelector((state: any): any => {
    if (state?.modalityOfStudy?.data?.desc) {
      const {
        progDesc,
        campusDesc: campus,
        isGraduated
      } = state.profile.data.academic;
      const { firstName, lastName, studentCode } = state.profile.data.profile;
      const profilePhoto = state.profilePhoto.data;
      return {
        modality: state?.modalityOfStudy?.data?.desc,
        name: `${firstName.toLowerCase()} ${lastName.toLowerCase()}`,
        profilePhoto,
        program: progDesc.toLowerCase(),
        studentCode,
        campus,
        isGraduated,
        ...formatProfile(state)
      };
    }
    return null;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) {
      dispatch(modalityActions.getModalityOfStudy());
    }
  }, [user]);

  return (
    <ModuleContainer containerType="subsection">
      <ProfileView user={user} />
    </ModuleContainer>
  );
};

export default ProfileViewController;
